module.exports = __webpack_public_path__ + "img/lb_logo.6ad03a28.png";